import { SelectOption } from 'common/types/types';

export const beadsOptions: SelectOption[] = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  // { label: '6+', value: 6 },
];

export const bathsOptions: SelectOption[] = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  // { label: '6+', value: 6 },
];
